import React from 'react'
import { useProfile } from '../../Layout/UserProfile/UserProfileProvider'
import { AttachmentProvider } from '../Context/AttachmentContext'
import TMClaimCreate from './TMClaimCreate'
import { GlobalFormProvider } from '../Context/GlobalFormStateContext'

const CreateClaim: React.FC = () => {
  const { userProfile } = useProfile()

  return (
    <React.Fragment>
      {!userProfile?.isVendor && (
        <AttachmentProvider>
          <GlobalFormProvider>
            <TMClaimCreate />
          </GlobalFormProvider>
        </AttachmentProvider>
      )}
    </React.Fragment>
  )
}
export default CreateClaim
